import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=1fc86083&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=js&"
export * from "./Broadcast.vue?vue&type=script&lang=js&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=1fc86083&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc86083",
  null
  
)

export default component.exports